/**
 * 首页焦点
 */

import { Row, Col } from 'antd';

const Focus = () => {
    return <>
        <div style={{ padding: '40px 0', color: '#fff', textAlign: 'center' }}>
            <Row>
                <Col offset={4} span={16}>
                    <p><span style={{ fontSize: '50px' }}>感兴趣吗？</span></p>
                    <p>欢迎联系我们，我们愿意为您解答任何有关信息化有关的疑难问题！</p>
                </Col>
            </Row>
        </div>
    </>
}

export default Focus;